<template>
  
      
    <!-- input container -->             
    <div class="row ch" style="position: relative; align-items: flex-end;">
      
          <!-- upload icon -->
           <div class="row ch left" style="padding: 12px;">
              <slot name="left"></slot>
           </div>
            
                
          <!-- input -->
          <!-- <at-ta :members="teamlist" name-key="name" :value="modelValue" @insert="mention" style="width: 100%;"> -->
            <textarea ref="area" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" @keydown.enter.exact.prevent="''"  @keydown.enter.exact="send()" style="background-color: #1C1C1C; width: 100%; margin: 0;padding: 10px 2px 12px;" placeholder="write message..." rows="1" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>                      
          <!-- </at-ta> -->

          <!-- send icon -->
           <div class="row ch right" style="padding: 12px;">
              <slot name="right"></slot>
           </div>
            


          <!-- support team select popover -->
         <!--  <div v-if="showMentionsPopup" class="column" style="position: absolute; top: -20px;  background-color: var(--g05); border-radius: 10px;">
            <div class="row">
              <p class="tag" v-for="(item, index) in db.supportTeam" :key="index">{{ item.name }}</p>
            </div>
          </div> -->

    </div>


</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
  //  
  },  
  props:{
    width: String,
    modelValue: String,
  },
  data() {
    return {    
     

    }
  },
  methods:{
    send(){
      this.$emit('send', true)
    },
    resetArea(){
      let area = this.$refs.area
      if (!area) return
      area.style.height = ''
      area.rows = '1'
      area.value = ''
    },
  },
 
});

</script>
<style scoped>
.container{
   width: 380px; 
   height: 100%; 
   border-radius: 20px; 
   background-color: var(--g05);   
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
</style>
